<template>
  <div class="main" id="main">
    <div class="headerBox">
      <div class="listTit">
        <span class="ranking">排名</span>
        <span class="lane">靶位</span>
        <span class="org van-hairline--left">单位</span>
        <span class="totalScore van-hairline--left">总分</span>
        <span class="currentCount van-hairline--left">本轮</span>
      </div>
    </div>
    <div class="matchList">
      <van-list finished>
        <van-cell v-for="(item,n) in showData.value" :key="n" :title="item">
          <div class="matchName" :class="item.remark">
            <div  class="borderBox van-hairline--bottom orgName"  >
              <span class="ranking">{{item.ranking}}</span>
              <span class="lane">{{item.lane}}</span>
              <span class="org">
                <sapn>{{item.org}}</sapn>
              </span>
              <span class="totalScore">{{item.count?item.count:item.totalScore}}</span>
              <span class="currentCount">{{item.currentCount}}</span>
            </div>
            <div class="svgBox" :class="{borderred:item.isSoff}">
              <div class="eliminatedBox " v-if="item.eliminated == 2"></div>
              <div class="stageScoreslist">
                <div class="tableHeaderShow" v-for="(data,n) in state.projectInfo.tableHeaderShow" :key="n">
                  <span>{{data}}</span>
                  <span>{{item.stageScores[n]?item.stageScores[n].score:''}}</span>
                </div>
              </div>
              <div class="svgItem" >
                <div class="targetContainer">
                  <div :class="{ shotType: item.sight == 1 }"></div>
                  <div class="playerName"></div>
                  <div class="name">{{item.playerName}}</div>
                  <div class="playerscore">{{lastPosition(item)}}</div>
                  <component
                    v-bind:is="svgName"
                    :dataitem="item.isSoff ? item.soffPosition : item.position"
                    :lastscore="lastPosition(item)"
                  ></component>
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs, onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
import svgm10ar from "../../components/10m/svg10mAR.vue";
import svgm10ap from "../../components/10m/svg10mAP.vue";
import svgm50ar from "../../components/50m/svg50mAR.vue"//步枪
import svgm50ap from "../../components/50m/svg50mAP.vue"
var opt;
export default {
  components: { svgm10ar, svgm10ap,svgm50ar, svgm50ap },
  setup(props, { refs, root }) {
    console.log(props.svgName)
    const data = reactive(createState)
    return {
        state: reactive(createState),
    };
  },
  props: {
    //指定接收的值，必须指定类型
    showData: Object,
    svgName: String
  },
  methods: {
    reverseFun(data){
      return data.reverse()
    },
    datatime(index, item) {
      if (this.showData.value.length != index) {
        const list = [];
        if (item.isSoff) {
          if(this.showData.value[index].soffPosition[0]){
            list.push({ ...this.showData.value[index].soffPosition[0] });
          }
          return list;
        } else {
          if(this.showData.value[index].position[0]){
            list.push({ ...this.showData.value[index].position[0] });
          }
          return list;
        }
      }
    },
    showName(index) {
      if (this.showData.value.length != index) {
        return this.showData.value[index + 1];
      }
    },
    lastPosition(item) {
      const data = item.isSoff ? item.soffPosition : item.position;
      if (data.length > 0) {
        let position = data[data.length - 1];
        return position.score;
      } else {
        return "";
      }
    }
  },
  mounted() {
    console.log("这是资格赛");
  }
};
</script>

<style lang="less" scoped>
.svgBox {
  width: 100%;
  height: 2.1rem;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  .eliminatedBox{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #ececec url('./logo-white.png') no-repeat 50%;
    background-size: 100% auto;
    z-index: 4;
  }
}
.stageScoreslist{
  width: 50%;
  height: 2.1rem;
  float: left;
  .tableHeaderShow{
    width: 100;
    height: 0.4rem;
    line-height: 0.4rem;
    span{
      float: left;
      width: 50%;
      height: 0.4rem;
      border-bottom: 1px solid #999;
    }
  }
}
.svgItem {
  width: 50%;
  height: 2.1rem;
  float: left;
  background: #ddd;
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
  background: #fff;
  z-index: 10;
  border-bottom: 1px solid #333;
  .title {
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis {
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
  .listTit {
    width: 96%;
    padding: 0 2%;
    height: 1rem;
    background: #fff;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1rem;
    border-top: 1px solid #333;
  }
}
.oddcolor {
  background: #ffffcc;
}
.ranking {
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.orgName {
  background: #6699cc;
  color: #fff;
}
.lane{
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.org {
  display: block;
  width: 30%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.orgsvg {
  display: block;
  width: 100%;
  height: 2.1rem;
  float: left;
  line-height: 1rem;
  position: absolute;
  top: 0;
  left: 28%;
  overflow: hidden;
  z-index: 2;
}
.currentCount {
  display: block;
  width: 15%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.totalScore {
  display: block;
  width: 27%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.QF {
  background-color: red;
  color: #fff;
}
.matchList {
  margin-top: 1rem;
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 3.1rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      text-align: center;
      .borderBox {
        width: 96%;
        height: 1rem;
        padding: 0 2%;
        position: relative;
        overflow: hidden;
        // border-bottom: 1px solid #333;
        font-size: 0.4rem;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
.targetContainer {
  background: #eee;
  width: 100%;
  height: 2rem;
  transform: scale(var(--transScale));
  margin-top: var(--margin);
  box-sizing: border-box;
  // border: 2px solid white;
  // background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  .name {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 70%;
    overflow: hidden;
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: 700;
    font-size: 0.4rem;
    color: #fff;
    text-align: left;
    text-indent: 0.2rem;
  }
  .playerscore {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: 700;
    font-size: 0.4rem;
    color: #fff;
    // text-align: right;
    text-indent: 2rem;
  }
  .playerName {
    z-index: 2;
    width: 100%;
    height: 0.6rem;
    background-color: #333399;
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>